<script setup>
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import searchFilterOptions from "../../../../../frontend/src/constants/searchFilterOptions";

const revenueRangeOptions = searchFilterOptions.revenueRange;
const stageOptions = searchFilterOptions.fundingSeries;

</script>

<template>
    <div>
        <StartupEditField
            type="select"
            field-name="revenueRange"
            label="Revenue Range"
            :options="revenueRangeOptions"
        />

        <StartupEditField
            type="select"
            field-name="stage"
            label="Funding Series"
            :options="stageOptions"
        />

        <StartupEditField
            field-name="totalRaised"
            label="Total Raised"
            type="number"
        />
    </div>
</template>

<style scoped>

</style>
